<section class="py-3 card settlements-container card-div">
  <div class="container-fluid d-flex flex-column h-100">

    <!-- Sticky Top Header Container -->
    <div class="sticky-top-container">
      <div class="row align-items-center mb-4 g-3">
        <div class="col-12 col-md-5 d-flex flex-column align-items-start header-left">
          <div class="sku-badge px-4 py-2 mb-2 d-inline-block">
            <h2 class="sku-name fw-bold m-0 text-break">Settlements</h2>
          </div>
          <span class="footer-text text-muted small">
            {{ cardValues.upcomingCount | number}} Upcoming &middot; {{ cardValues.historyCount | number }} Settled &middot; {{ selectedMonth }}
          </span>
        </div>

        <!-- Right Controls Container -->
        <div class="col-12 col-md-7 d-flex align-items-center gap-2 justify-content-start justify-content-md-end flex-wrap header-right">
          <button class="btn premium-btn-dark py-2 px-4" (click)="openRecordManualSettlementModal(manualSettlementModal)">
            Record Manual Settlement
          </button>
        </div>
      </div>
    </div>

    <!-- Responsive Layout Row -->
    <div class="row g-4 flex-grow-1" style="min-height: 0;">
    <div class="col-lg-9 col-md-8 col-12 order-md-1 order-2 d-flex flex-column h-100" style="min-height: 0;">
      <div class="tabs-row mb-3">
        <div class="tab-segments d-inline-flex gap-2">
          <button type="button" class="btn tab-segment-btn"
            [class.active]="activeTab === 'upcoming'" (click)="switchTab('upcoming')">
            Upcoming <span class="tab-badge ms-1">{{ cardValues.upcomingCount | number }}</span>
          </button>
          <button type="button" class="btn tab-segment-btn"
            [class.active]="activeTab === 'history'" (click)="switchTab('history')">
            History <span class="tab-badge ms-1">{{ cardValues.historyCount | number}}</span>
          </button>
        </div>
      </div>

      <div class="search-filters-card py-md-3 py-1 mb-3 bg-white rounded border" [class]="activeTab === 'history' ? 'px-1' : 'px-3 '">
        <div class="row" [class]="activeTab === 'history' ? 'g-1' : 'g-3'">
          <!-- Source Account Filter -->
          <div [class]="activeTab === 'history' ? 'col-md-3 col-6' : 'col-md-4 col-6'">
            <ng-select [items]="paymentAccounts" bindLabel="accountName" bindValue="_id" [(ngModel)]="filters.accountId"
              [clearable]="true" [searchable]="true" [searchFn]="customSearchFn" placeholder="All sources"
              [loading]="paymentAccountsObj.loader"
              class="custom-ng-select filter-account-select w-100" (search)="onFilterPaymentAccountInputChange($event)"
              (scrollToEnd)="onFilterPaymentAccountScrollToEnd()" (change)="onFilterChange()">
              <ng-template ng-option-tmp let-item="item">
                <div class="d-flex flex-column py-1 text-start align-items-start" style="align-items: flex-start !important; text-align: left !important;">
                  <span class="fw-medium" style="font-size: 13px !important; line-height: 1.2;">{{ item.accountName }}</span>
                  @if (item.company?.name || item.paymentType) {
                    <small class="text-muted  mt-0.5" style="font-size: 11px !important; line-height: 1.2;">
                      {{ item.company?.name || '' }}{{ (item.company?.name && item.paymentType) ? ' - ' : '' }}@if(item.paymentType !== 'UPI'){ {{ item.paymentType | capitalSpace}} } @else{ {{ item.paymentType || '' }} }
                    </small>
                  }
                </div>
              </ng-template>
            </ng-select>
          </div>

          <!-- Settlement Type Filter -->
          <div [class]="activeTab === 'history' ? 'col-md-3 col-6' : 'col-md-4 col-6'">
            <ng-select [items]="settlementTypes" bindLabel="label" bindValue="value" [(ngModel)]="filters.selectedType"
              [clearable]="false" [searchable]="false" placeholder="All settlements"
              class="custom-ng-select filter-select w-100" (change)="onFilterChange()">
            </ng-select>
          </div>

          <!-- Branch Filter -->
          <div [class]="activeTab === 'history' ? 'col-md-3 col-6' : 'col-md-4 col-12'">
            <ng-select [items]="branches" bindLabel="name" bindValue="_id" [(ngModel)]="filters.company"
              [clearable]="true" [searchable]="true" placeholder="All branches"
              class="custom-ng-select filter-select w-100" (change)="onFilterChange()">
            </ng-select>
          </div>

          <!-- Date Range Filter -->
          @if (activeTab === 'history') {
            <div class="col-md-3 col-12">
              <div class="dropdown filter-period-dropdown w-100">
                <button class="btn period-btn d-flex align-items-center gap-1 py-2 px-1 w-100" [ngbTooltip]="selectedDateRangeText"
                  type="button" id="settlementsDateDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                  <fa-icon [icon]="faCalendarDays" class="text-muted icon-sm"></fa-icon>
                  <span class="text-truncate">{{ selectedDateRangeText }}</span>
                </button>
                <ul class="dropdown-menu shadow-sm border-0 mt-1 w-100" aria-labelledby="settlementsDateDropdown">
                  <li><a class="dropdown-item cursor-pointer small fw-semibold" (click)="applyDaysRange('all', 'All time')">All time</a></li>
                  <li><a class="dropdown-item cursor-pointer small" (click)="applyDaysRange(1, 'Today')">Today</a></li>
                  <li><a class="dropdown-item cursor-pointer small" (click)="applyDaysRange(7, 'Last 7 Days')">Last 7 Days</a></li>
                  <li><a class="dropdown-item cursor-pointer small" (click)="applyDaysRange(30, 'Last 30 Days')">Last 30 Days</a></li>
                  <li><a class="dropdown-item cursor-pointer small" (click)="applyDaysRange(90, 'Last 90 Days')">Last 90 Days</a></li>
                  <li><a class="dropdown-item cursor-pointer small fw-semibold text-primary" (click)="openCalendar()">Custom Date</a></li>
                </ul>
              </div>
            </div>
          }
        </div>
      </div>

      <div class="table-card rounded bg-white border p-3 position-relative">
        @if (activeTab === 'upcoming') {
          <div class="table-responsive">
            <table class="table align-middle custom-settlements-table">
              <thead>
                <tr>
                  <th>Source account</th>
                  <th>Destination</th>
                  <th>Scheduled</th>
                  <th>Amount</th>
                  <th>Settlement</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                @for (item of upcomingList; track item._id || $index) {
                  <tr>
                    <!-- Source Account -->
                    <td>
                      <div class="text-style-1 mb-0.5">
                        {{ item.accountDetails?.accountName || '-' }}
                      </div>
                      <div class="text-style-2">
                        Payment account &middot; @if(item.accountDetails?.paymentType !== 'UPI') { {{ item.accountDetails?.paymentType | capitalSpace }} } @else{ {{ item.accountDetails?.paymentType || '-' }} }
                      </div>
                      <div class="text-style-2">
                        {{ item.companyDetails?.name || '-' }}
                      </div>
                    </td>
                    <td>
                      <div class="text-style-3">
                        {{ item.balanceAccountDetails?.accountName || '-' }}
                      </div>
                    </td>
                    <td>
                      <div class="text-style-4 mb-0.5">
                        @if(item.scheduledDate){
                          {{  item.scheduledDate | date:'dd MMMM yyyy, HH:mm a':'Asia/Kolkata' }}
                        } @else {
                          -
                        }
                      </div>
                      <div class="text-style-2">
                        @if (item?.settlementType === 'Auto') {
                          Delayed
                        } @else {
                          Manual
                        }
                      </div>
                    </td>
                    <td>
                      <div class="text-style-6 text-nowrap">
                        {{ item.netPending < 0 ? '-' : '' }} ₹{{ (item.netPending < 0 ? -item.netPending : item.netPending) | number }}
                      </div>
                    </td>
                    <td>
                      <span class="badge-common" [ngClass]="item?.settlementType === 'Auto' ? 'badge-auto' : 'badge-manual'">
                        {{ item?.settlementType || '-' }}
                      </span>
                    </td>
                    <td>
                      @if (item?.settlementType === 'Manual') {
                        <button type="button" class="btn btn-outline-record-action py-1 px-2 fw-semibold d-inline-flex align-items-center gap-2 shadow-none"
                          (click)="quickRecordSettlement(item, manualSettlementModal)">
                          <fa-icon [icon]="faExchangeAlt"></fa-icon>
                          <span>Record</span>
                        </button>
                      }
                    </td>
                  </tr>
                }

                @if (loader) {
                  <tr>
                    <td colspan="6">
                      <div class="d-flex align-items-center justify-content-center py-4">
                        <app-loader [loadingIcon]="true"></app-loader>
                      </div>
                    </td>
                  </tr>
                }

                @if (errorMessage) {
                  <tr>
                    <td colspan="6">
                      <div class="alert alert-danger my-2 small rounded-3">
                        {{ errorMessage }}
                      </div>
                    </td>
                  </tr>
                }

                <!-- Empty State Row inside Table -->
                @if (!loader && !errorMessage && upcomingList.length === 0) {
                  <tr>
                    <td colspan="6" class="text-center py-5 text-muted">
                      No upcoming settlements found matching the criteria.
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }

        <!-- HISTORY VIEW -->
        @if (activeTab === 'history') {
          <div class="table-responsive" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="500" (scrolled)="onScrollHistory()">
            <table class="table align-middle custom-settlements-table">
              <thead>
                <tr>
                  <th>Settlement</th>
                  <th>Source account</th>
                  <th>Destination</th>
                  <th>Settled on</th>
                  <th>Amount</th>
                  <th>Type</th>
                </tr>
              </thead>
              <tbody>
                @for (item of historyList; track item._id || $index) {
                  <tr>
                    <!-- Settlement ID -->
                    <td>
                      <div class="text-style-8 mb-0.5">
                        {{ item.settlementId|| '-' }}
                      </div>
                      <div class="text-style-9">
                        Settled
                      </div>
                    </td>

                    <td>
                      <div class="text-style-1 mb-0.5">
                        {{ item.accountId?.accountName || '-' }}
                      </div>
                      <div class="text-style-2">
                        Payment account &middot; {{ item.accountId?.paymentType || '-' }}
                      </div>
                      <div class="text-style-2">
                        {{ item.company?.name || '-' }}
                      </div>
                    </td>

                    <td>
                      <div class="text-style-3">
                        {{ item.balanceAccountId?.accountName || '-' }}
                      </div>
                    </td>

                    <td>
                      <div class="text-style-10">
                        {{ item.settlementDate  | date:'dd MMMM yyyy':'Asia/Kolkata' }}
                      </div>
                    </td>

                    <td>
                      <div class="text-style-6 text-nowrap">
                        {{ item.amount < 0 ? '-' : '' }} ₹{{ (item.amount < 0 ? -item.amount : item.amount) | number }}
                      </div>
                    </td>

                    <td>
                      <span class="badge-common" [ngClass]="{
                        'badge-auto': (item.settlementType || item.type) === 'Auto',
                        'badge-immediate': (item.settlementType || item.type) === 'Immediate',
                        'badge-manual': (item.settlementType || item.type) === 'Manual'
                      }">
                        {{ item.settlementType || item.type || '-' }}
                      </span>
                    </td>
                  </tr>
                }

                @if (loader) {
                  <tr>
                    <td colspan="6">
                      <div class="d-flex align-items-center justify-content-center py-4">
                        <app-loader [loadingIcon]="true"></app-loader>
                      </div>
                    </td>
                  </tr>
                }

                @if (errorMessage) {
                  <tr>
                    <td colspan="6">
                      <div class="alert alert-danger my-2 small rounded-3">
                        {{ errorMessage }}
                      </div>
                    </td>
                  </tr>
                }

                @if (!loader && !errorMessage && historyList.length === 0) {
                  <tr>
                    <td colspan="6" class="text-center py-5 text-muted">
                      No settled history found matching the criteria.
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    </div>

    <div class="col-lg-3 col-md-4 col-12 order-md-2 order-1">
      <div class="row g-3">
        <div class="col-12 col-sm-6 col-md-12">
          <div class="summary-card p-3 rounded bg-white border d-flex flex-column justify-content-between h-100">
            <div>
              <div class="summary-card-title mb-1">Upcoming</div>
              <div class="summary-card-value my-2">{{ cardValues.upcomingCount | number }}</div>
            </div>
            <div class="summary-card-subtitle">Awaiting settlement</div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-12">
          <div class="summary-card p-3 rounded bg-white border d-flex flex-column justify-content-between h-100">
            <div>
              <div class="summary-card-title mb-1">Settled this month</div>
              <div class="summary-card-value my-2">{{ cardValues.settledAmount | shortNumber }}</div>
            </div>
            <div class="summary-card-subtitle">{{ cardValues.settledCount | number}} Settlements</div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-12">
          <div class="summary-card p-3 rounded bg-white border d-flex flex-column justify-content-between h-100">
            <div>
              <div class="summary-card-title mb-1">Next scheduled</div>
              <div class="summary-card-value my-2 text-truncate" style="font-size: 20px;">
                @if(cardValues.nextSheduleDate) {
                  {{cardValues.nextSheduleDate | date:'d MMM':'Asia/Kolkata'}}
                } @else{
                  -
                }
              </div>
            </div>
            <div class="summary-card-subtitle"> </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #manualSettlementModal>
  <div class="manual-settlement-card-popup p-4">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <div class="d-flex align-items-center gap-3">
        <div class="popup-icon-circle d-flex align-items-center justify-content-center">
          <fa-icon [icon]="faExchangeAlt" class="text-primary fs-5"></fa-icon>
        </div>
        <div>
          <h3 class="popup-top-heading mb-0.5">Record Manual Settlement</h3>
          <p class="popup-bottom-heading mb-0">Move funds from a payment account to a balance account.</p>
        </div>
      </div>
      <button [disabled]="modalLoader" type="button" class="btn-close-custom shadow-none" (click)="closeModal()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>

    <div class="popup-instruction mb-4 d-flex align-items-start gap-2">
      <fa-icon [icon]="faInfoCircle" class="info-icon mt-0.5"></fa-icon>
      <div>
        For payment accounts with Manual settlement, choose source and destination here.
      </div>
    </div>

    @if (modalErrorMessage) {
      <div class="alert alert-danger py-2 mb-3 small d-flex justify-content-between align-items-center rounded-3">
        <span>{{ modalErrorMessage }}</span>
        <button type="button" class="btn-close small py-1 shadow-none" style="font-size: 0.75rem;" (click)="modalErrorMessage = ''"></button>
      </div>
    }

    <form [formGroup]="manualSettlementForm" (ngSubmit)="saveManualSettlement()" class="d-flex flex-column gap-2">
      <div>
        <label for="sourceAccountSelect" class="form-label premium-form-label mb-1">Source payment account *</label>
        <ng-select labelForId="sourceAccountSelect" [items]="manualPaymentAccounts" bindLabel="accountName" bindValue="_id" formControlName="accountId"
          [clearable]="false" [searchable]="true" [searchFn]="customSearchFn" placeholder="Select source account" 
          [loading]="manualPaymentAccountsObj.loader"
          class="custom-ng-select" (search)="onManualPaymentAccountInputChange($event)" (scrollToEnd)="onManualPaymentAccountScrollToEnd()">
          <ng-template ng-option-tmp let-item="item">
            <div class="d-flex flex-column py-1 text-start align-items-start" style="align-items: flex-start !important; text-align: left !important;">
              <span class="fw-medium" style="font-size: 13px !important; line-height: 1.2;">{{ item.accountName }}</span>
              @if (item.company?.name || item.paymentType) {
                <small class="text-muted text-lowercase mt-0.5" style="font-size: 11px !important; line-height: 1.2;">
                  {{ item.company?.name || '' }}{{ (item.company?.name && item.paymentType) ? ' - ' : '' }}{{ item.paymentType || '' }}
                </small>
              }
            </div>
          </ng-template>
        </ng-select>
        @if (manualSettlementForm.get('accountId')?.touched && manualSettlementForm.get('accountId')?.invalid) {
          <div class="text-danger small mt-1">
            @if (manualSettlementForm.get('accountId')?.errors?.['required']) {
              Source payment account is required
            }
          </div>
        }
      </div>

      <div>
        <label for="destAccountSelect" class="form-label premium-form-label mb-1">Destination balance account *</label>
        <ng-select labelForId="destAccountSelect" [items]="balanceAccounts" bindLabel="accountName" bindValue="_id" formControlName="balanceAccountId"
          [clearable]="false" placeholder="Select balance account" class="custom-ng-select">
        </ng-select>
        @if (manualSettlementForm.get('balanceAccountId')?.touched && manualSettlementForm.get('balanceAccountId')?.invalid) {
          <div class="text-danger small mt-1">
            @if (manualSettlementForm.get('balanceAccountId')?.errors?.['required']) {
              Destination balance account is required
            }
          </div>
        }
      </div>

      <!-- Amount -->
      <div>
        <label for="settlementAmount" class="form-label premium-form-label mb-1">Amount *</label>
        <input id="settlementAmount" type="number" class="form-control premium-input" formControlName="amount"
          placeholder="e.g. 45200" />
        @if (manualSettlementForm.get('amount')?.touched && manualSettlementForm.get('amount')?.invalid) {
          <div class="text-danger small mt-1">
            @if (manualSettlementForm.get('amount')?.errors?.['required']) {
              Amount is required
            }
            @if (manualSettlementForm.get('amount')?.errors?.['notZero']) {
              Amount cannot be 0
            }
          </div>
        }
      </div>

      <div #dateContainer class="position-relative">
        <span class="form-label premium-form-label mb-1 d-block">Settlement date *</span>
        <div class="premium-input d-flex align-items-center justify-content-between cursor-pointer bg-white"
          [ngClass]="{'form-disabled': modalLoader}"
          (click)="!modalLoader && dp.toggle()" >
          <span class="fw-medium text-dark">{{ settlementDateFormatted }}</span>
          <fa-icon [icon]="faChevronDown" class="text-muted small"></fa-icon>
        </div>
        @if (manualSettlementForm.get('settlementDate')?.touched && manualSettlementForm.get('settlementDate')?.invalid) {
          <div class="text-danger small mt-1">
            @if (manualSettlementForm.get('settlementDate')?.errors?.['required']) {
              Settlement date is required
            }
          </div>
        }
        <input class="datepicker-hidden-input" name="dp" ngbDatepicker #dp="ngbDatepicker"
          [positionTarget]="dateContainer" [maxDate]="maxDate" [startDate]="selectedNgbDate"
          [(ngModel)]="selectedNgbDate" [ngModelOptions]="{standalone: true}" (dateSelect)="onDateSelect($event)"/>
      </div>

      <!-- Action Buttons -->
      <div class="d-flex flex-column gap-2 mt-3">
        <button type="submit" class="btn premium-btn-dark w-100 py-2 d-flex justify-content-center align-items-center gap-2"
          [disabled]="manualSettlementForm.invalid || modalLoader">
          <span>Save Settlement</span>
          @if (modalLoader) {
            <fa-icon [icon]="faSpinner" [animation]="'spin'" class="me-1"></fa-icon>
          }
        </button>
        <button
          type="button"
          class="btn premium-btn-cancel w-100 py-2"
          [disabled]="modalLoader"
          (click)="closeModal()"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</ng-template>

@if(toasterMessage) {
<app-toaster [title]="toasterMessage" (closeToaster)="closeToaster()"></app-toaster>
}